import React, { useState } from 'react'
import PageHeader from '../../components/PageHeader'
import InventoryTable from './InventoryTable'
import dayjs from 'dayjs'

const Inventory = () => {
  const [eventData, setEventData] = useState(dayjs() )

  const handleDateChange = (e) => {
    const statusValue = e.$d
    const dateDaoily = statusValue.toISOString().substring(0, 10)
    setEventData(dateDaoily)
  }

  return (
    <div className="dashboard-container">
      <PageHeader title="Inventory" hideDateRange = {true} handleDateChange={handleDateChange}/>
      <InventoryTable eventData={eventData}/>
    </div>
  )
}

export default Inventory